class ClientActivationConfirmUsersController {
    static controller($scope, $state) {
        'ngInject';

        $scope.userName = $state.params.userName;
    };
}

export default ClientActivationConfirmUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-activation-confirm.users.controller.js